import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import MainLayout from '../../components/Layout/MainLayout';

const AILLM: React.FC = () => {
  return (
    <MainLayout>
      <Box sx={{ p: 3 }}>
        <Paper elevation={2} sx={{ p: 4, borderRadius: 2 }}>
          <Typography variant="h4" component="h1" gutterBottom>
            IA y LLM
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Esta sección estará disponible próximamente.
          </Typography>
        </Paper>
      </Box>
    </MainLayout>
  );
};

export default AILLM;
